import { callExternalApi, CallResult } from '../callExternalApi';
import { AdviseSupplier, SupplierDirectoryRow } from '../../types/advise';

export const fetchAdviseSuppliers = async (): Promise<CallResult<AdviseSupplier[]>> => {
  return callExternalApi<AdviseSupplier[]>({
    url: 'api/advise/suppliers',
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const fetchAdviseSupplierDirectory = async (): Promise<CallResult<SupplierDirectoryRow[]>> => {
  return callExternalApi<SupplierDirectoryRow[]>({
    url: 'api/advise/suppliers/directory',
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const fetchAdviseSupplierById = async (id: string): Promise<CallResult<AdviseSupplier>> => {
  return callExternalApi<AdviseSupplier>({
    url: `api/advise/suppliers/${id}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const createAdviseSupplier = async (supplier: Partial<AdviseSupplier>): Promise<CallResult<AdviseSupplier>> => {
  return callExternalApi<AdviseSupplier>({
    url: 'api/advise/suppliers',
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    data: supplier
  });
};

export const updateAdviseSupplier = async (
  id: string,
  supplier: Partial<AdviseSupplier>
): Promise<CallResult<AdviseSupplier>> => {
  return callExternalApi<AdviseSupplier>({
    url: `api/advise/suppliers/${id}`,
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    data: supplier
  });
};

export const deleteAdviseSupplier = async (id: string): Promise<CallResult<void>> => {
  return callExternalApi<void>({
    url: `api/advise/suppliers/${id}`,
    method: 'DELETE',
    headers: { 'content-type': 'application/json' }
  });
};
